export let mechanismOpenApplyHeader = [
    {prop: 'schemeName', label: '计划名称'},
    {prop: 'professionName', label: '专业类型', width: '80'},
    {prop: 'raceTypeName', label: '大赛类型', width: '80'},
    {prop: 'orgName', label: '机构名称'},
    {prop: 'provinceName', label: '所属省份', width: '100'},
    {prop: 'statusName', label: '审批状态', width: '80'},
    {prop: 'rejectCause', label: '驳回原因'},
]

export let accountManageHeader = [
    {prop: 'accountName', label: '账号'},
    {prop: 'name', label: '账号名称'},
]